import React from "react";

import { CpButton } from "@components";
import { SelectDataItem } from "./utils";

export type FooterProps = {
  close: () => void;
  value: SelectDataItem[];
  clearAll: () => void;
};

export const Footer = (props: FooterProps) => {
  const { close, value, clearAll } = props;

  return (
    <>
      <CpButton btnType="flat" onClick={close} type="button">
        Done
      </CpButton>
      {!!value.filter((v) => !v.disabled).length && (
        <CpButton btnType="tertiary" onClick={clearAll} type="button">
          Clear all
        </CpButton>
      )}
    </>
  );
};
